import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ItemDetailSectionSkeleton } from '@/experiences/sales-portal/domain/items/components/item-detail-section-skeleton';
import { VariantPackListSkeleton } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/item-detail-content/details-tab/variant-pack/variant-pack-list-skeleton';
import { View } from 'react-native';

/**
 * Details-tab loading state — the section skeleton plus a variant-pack-list
 * skeleton matching the related-packs section the user is waiting on.
 */
export const ItemDetailDetailsLoadingSkeleton: React.FC = () => {
  const [styles] = useStyles();
  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.order_entry.item_detail.a11y.loading',
      )}
      accessibilityRole="progressbar"
      style={styles.skeletonContainer}
    >
      <ItemDetailSectionSkeleton />
      <VariantPackListSkeleton />
    </View>
  );
};

const useStyles = createStyles(() => ({
  skeletonContainer: {
    flexDirection: 'column',
  },
}));
